import { render, staticRenderFns } from "./AllChannels.html?vue&type=template&id=ffcb0b94&scoped=true&"
import script from "./AllChannels.js?vue&type=script&lang=js&"
export * from "./AllChannels.js?vue&type=script&lang=js&"
import style0 from "./AllChannels.scss?vue&type=style&index=0&id=ffcb0b94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcb0b94",
  null
  
)

export default component.exports